interface WhiteCrossIconProps {
  width?: number;
  height?: number;
}
const WhiteCrossIcon: React.FC<WhiteCrossIconProps> = ({
  width = 11,
  height = 11,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.09048 0.0103511C4.27584 0.0884212 3.66994 0.260833 2.98397 0.609762C2.17137 1.02307 1.44219 1.67665 0.91051 2.4682C0.819177 2.60416 0.663682 2.87983 0.564934 3.08081C0.205493 3.81233 0.0326514 4.50076 0.00361159 5.3163C-0.0290179 6.23304 0.159494 7.10553 0.567363 7.92565C0.854687 8.50337 1.1499 8.91208 1.61785 9.38005C2.09095 9.85313 2.50151 10.1486 3.08069 10.4327C3.48482 10.6309 3.74575 10.7274 4.15545 10.8302C5.2305 11.0998 6.30871 11.0481 7.35905 10.6766C7.67743 10.564 8.23321 10.2854 8.51894 10.0953C9.16132 9.66782 9.75104 9.0633 10.1719 8.40084C10.3267 8.15711 10.5755 7.64288 10.677 7.35687C11.1819 5.93396 11.0941 4.40676 10.4304 3.07237C10.1626 2.53385 9.86443 2.11179 9.44579 1.6786C8.98156 1.19819 8.52621 0.866736 7.91708 0.565762C7.28038 0.251182 6.68714 0.0832623 5.98253 0.0181538C5.76354 -0.00207305 5.26569 -0.00643655 5.09048 0.0103511ZM4.0214 3.3944C4.04784 3.40792 4.3911 3.73929 4.78418 4.13076L5.49889 4.84255L6.2136 4.12926C6.71104 3.63283 6.95372 3.40541 7.0119 3.38121C7.18642 3.3086 7.41593 3.35288 7.53303 3.48176C7.65226 3.61294 7.68635 3.81852 7.61669 3.98599C7.59249 4.04418 7.36507 4.28686 6.86864 4.7843L6.15535 5.49901L6.86864 6.21372C7.36507 6.71116 7.59249 6.95384 7.61669 7.01202C7.68635 7.17949 7.65226 7.38507 7.53303 7.51625C7.41593 7.64514 7.18642 7.68942 7.0119 7.61681C6.95372 7.59261 6.71104 7.36519 6.2136 6.86876L5.49889 6.15547L4.78418 6.86876C4.28674 7.36519 4.04406 7.59261 3.98587 7.61681C3.68445 7.74221 3.35166 7.53764 3.34463 7.22263C3.33988 7.0094 3.34465 7.00328 4.11994 6.22432L4.84215 5.49873L4.12901 4.78415C3.63267 4.28681 3.40529 4.04418 3.38109 3.98599C3.28969 3.76629 3.37677 3.50205 3.57508 3.39735C3.7016 3.33056 3.89415 3.3293 4.0214 3.3944Z"
        fill="white"
      />
    </svg>
  );
};

export default WhiteCrossIcon;
